import SelectAccessTypePopup from 'containers/Warehouse/MagAccess/popups/SelectAccessTypePopup'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import { AccessType } from 'containers/Warehouse/hooks/useAccessParams'
import NewAccess from 'containers/Warehouse/MagAccess/NewAccess'
import { LOCATION_STATES } from 'utils/constants'
import useFetchedData from 'hooks/useFetchedData'
import useTranslation from 'hooks/useTranslation'
import useWarehouses from 'hooks/useWarehouses'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxDispatch } from 'store'
import Loading from 'components/Loading'
import Error from 'components/Error'
import { sharings } from 'rest/urls'
import ShareItem from './Item'
import React from 'react'

export interface Sharing {
  userName: string
  userPhone: number
  permissions: warehouse.WarehouseSharing[]
}

export type PopupProps = {
  type: 'addAccess'
} | {
  type: 'share',
  body: {
    action: AccessType
    permissionId: string
    warehouseId: string
  }
}

const Share: React.FC = () => {
  const { data, isLoading, reload } = useFetchedData<Sharing[]>(sharings, '', 'GET')
  const { popup, openPopup } = usePopupState<PopupProps>()
  const warehouses = useWarehouses()

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('account')
  const { goBack, replace } = useHistory()

  const isAnyWarehouseAvailableForShare = warehouses?.some(warehouse => warehouse.gateHasOnlineAccess || warehouse.hasOnlineAccess)

  return (
    <>
      {popup?.type === 'addAccess' && <SelectAccessTypePopup
        selectType={type => {
          replace(window.location.pathname, LOCATION_STATES.popup({ type: 'share', body: { action: type } }))
        }}
      />}
      {popup?.type === 'share' && <Popup>
        <NewAccess
          isPopup
          warehouseId={popup.body.warehouseId}
          permissionId={popup.body.permissionId}
          action={popup.body.action}
          callback={() => {
            goBack()
            reload()
          }}
        />
      </Popup>}

      <div className='account__share'>
        <div className='account__header title'>
          <div>{t('shares')}</div>
          <div>{t('subTitle')}</div>
        </div>

        <div className='addNew__button__container'>
          <span
            className={`addNew__button --secFont${isAnyWarehouseAvailableForShare ? '' : ' --disabled'}`}
            onClick={() => {
              if (isAnyWarehouseAvailableForShare) {
                openPopup({ type: 'addAccess' })
              } else {
                dispatch(addNotification({ message: 'Nie masz obecnie magazynu do udostępnienia!', type: 'info' }))
              }
            }}>{t('new')} →</span>
        </div>

        <div className='account__list'>
          {isLoading
            ? <Loading />
            : data && data.length > 0
              ? data.map((values) => <ShareItem
                {...values}
                key={`${values.userName}_${values.userPhone}`}
                openPopup={openPopup}
              />)
              : <Error
                staticPos
                text={t('noItem')}
              />}
        </div>
      </div>
    </>
  )
}

export default Share